import { classNames } from "@greeter/util";
import {
  IconCancel,
  IconCheck,
  IconMinus,
  IconPencil,
  IconPlus,
  IconTrash,
} from "@tabler/icons-react";
import { Card, CardProps } from "../Card";

import css from "./QuantityControls.module.scss";

export type ButtonProps = CardProps & {
  disabled?: boolean;
};

export function PlusButton({ onClick, disabled, ...props }: ButtonProps) {
  return (
    <Card
      variant="green"
      {...classNames(css.Button, disabled && css.Disabled)}
      onClick={(e) => {
        e.stopPropagation();
        e.preventDefault();
        if (disabled) return;
        onClick?.(e);
      }}
      {...props}
    >
      <Card.Content
        style={{ padding: 0, display: "grid", placeItems: "center" }}
      >
        <IconPlus width={15} height={15} />
      </Card.Content>
    </Card>
  );
}

export function ConfirmButton({ onClick, disabled, ...props }: ButtonProps) {
  return (
    <Card
      variant="green"
      {...classNames(css.Button, disabled && css.Disabled)}
      onClick={(e) => {
        e.stopPropagation();
        if (disabled) return;
        onClick?.(e);
      }}
      {...props}
    >
      <Card.Content
        style={{ padding: 0, display: "grid", placeItems: "center" }}
      >
        <IconCheck width={15} height={15} />
      </Card.Content>
    </Card>
  );
}

export function MinusButton({ onClick, disabled, ...props }: ButtonProps) {
  return (
    <Card
      variant="green"
      {...classNames(css.Button, disabled && css.Disabled)}
      onClick={(e) => {
        e.stopPropagation();
        if (disabled) return;
        onClick?.(e);
      }}
      {...props}
    >
      <Card.Content
        style={{ padding: 0, display: "grid", placeItems: "center" }}
      >
        <IconMinus width={15} height={15} />
      </Card.Content>
    </Card>
  );
}

export function EditButton({ onClick, disabled, ...props }: ButtonProps) {
  return (
    <Card
      variant="yellow"
      {...classNames(css.Button, disabled && css.Disabled)}
      onClick={(e) => {
        if (disabled) return;
        onClick?.(e);
      }}
      {...props}
    >
      <Card.Content
        style={{ padding: 0, display: "grid", placeItems: "center" }}
      >
        <IconPencil width={15} height={15} />
      </Card.Content>
    </Card>
  );
}

export function TrashButton({ onClick, disabled, ...props }: ButtonProps) {
  return (
    <Card
      variant="yellow"
      {...classNames(css.Button, disabled && css.Disabled)}
      onClick={(e) => {
        e.stopPropagation();
        if (disabled) return;
        onClick?.(e);
      }}
      {...props}
    >
      <Card.Content
        style={{ padding: 0, display: "grid", placeItems: "center" }}
      >
        <IconTrash width={15} height={15} />
      </Card.Content>
    </Card>
  );
}

export function CancelButton({ onClick, disabled, ...props }: ButtonProps) {
  return (
    <Card
      variant="yellow"
      {...classNames(css.Button, disabled && css.Disabled)}
      onClick={(e) => {
        e.stopPropagation();
        if (disabled) return;
        onClick?.(e);
      }}
      {...props}
    >
      <Card.Content
        style={{ padding: 0, display: "grid", placeItems: "center" }}
      >
        <IconCancel width={15} height={15} />
      </Card.Content>
    </Card>
  );
}

export function QuantityValue({
  className,
  ...props
}: React.ComponentProps<"input">) {
  return (
    <input
      type="text"
      inputMode="numeric"
      {...classNames(css.QuantityValue, className)}
      {...props}
    />
  );
}

export function QuantityControls({
  className,
  ...props
}: React.ComponentProps<"div">) {
  return <div {...classNames(css.QuantityControls, className)} {...props} />;
}

QuantityControls.TrashButton = TrashButton;
QuantityControls.EditButton = EditButton;
QuantityControls.PlusButton = PlusButton;
QuantityControls.MinusButton = MinusButton;
QuantityControls.ConfirmButton = ConfirmButton;
QuantityControls.CancelButton = CancelButton;
QuantityControls.Value = QuantityValue;
